export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M15.3 2.7c.3.3.3.8 0 1.2l-1.6 1.5-3-3.1L12 .7c.4-.3.9-.3 1.2 0l2 2zM.5 15.5v-3.1l9.2-9.2 3.1 3-9.2 9.3H.5z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "#34333A",
    "viewBox": "0 0 16 16"
  }
};